import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      cards: this.el.querySelectorAll('.featured-vertical-cards__card')
    };
  }

  addListeners() {
    const { cards } = this.dom;

    cards.forEach(card =>
      card.addEventListener('mouseover', this.onHoverCard.bind(this))
    );
    cards.forEach(card =>
      card.addEventListener('mouseleave', this.onLeaveCard.bind(this))
    );
  }

  onHoverCard(e) {
    this.dom.cards.forEach(
      card => !card.contains(e.target) && card.classList.add('light-opacity')
    );
  }

  onLeaveCard(e) {
    this.dom.cards.forEach(
      card => !card.contains(e.target) && card.classList.remove('light-opacity')
    );
  }
}

export default Module;
